import { em, rem } from 'polished'
import styled from 'styled-components'

import { ChatCommentStyled } from '../components/ChatComment/styles/ChatCommentStyled'

interface IChatStyledProps {}

export const ChatStyled = styled.div<IChatStyledProps>`
  font-size: ${rem(16)};

  ${ChatCommentStyled} + ${ChatCommentStyled} {
    margin-top: ${em(12)};
  }
`
